
interface UuidGeneratorOptions {
    length: number;
}

export class UuidGenerator {

    protected options: UuidGeneratorOptions;

    constructor(options?: UuidGeneratorOptions) {
        this.options = Object.assign({}, this.defaults, options);
    }

    get defaults() {
        return {
            length: 16
        }
    }


    public uuid() {
        const self = this;
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
            const r = Math.random() * self.options.length | 0;
            const v = c === 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(self.options.length);
        });
    }
}



// WEBPACK FOOTER //
// ./js/utils/UuidGenerator.ts